import { AlertCircleIcon } from 'lucide-react';

import { cn } from '../../../utils/cn.js';
import { INVOICES_STATES } from '../../../utils/constants.js';

import PaperIcon from '../../icons/paper.jsx';
import { DialogVoidInvoice } from './dialogs/customer-void-invoice.jsx';
import PortalSubHeading from './heading-sub.jsx';

export default function CardInvoice({
  invoice,
  shop,
  minEntryAmount,
  className,
  pending = false,
  rejected = false,
}) {
  const couponsEquivalent = Math.floor(
    invoice.amount / parseFloat(minEntryAmount),
  );

  return (
    <div
      className={cn(
        'relative flex flex-col items-start rounded-[24px] border border-portal-foreground bg-portal-background text-portal-text',
        className,
      )}
    >
      <div className="flex w-full items-center gap-4 p-6">
        <div className="w-5">
          <PaperIcon />
        </div>
        <PortalSubHeading className="text-left">
          Fatura {invoice.code}
        </PortalSubHeading>
      </div>
      <div className="flex w-full flex-col items-start gap-1 border-t-[3px] border-dotted border-portal-foreground p-6 text-sm">
        {invoice.reason && invoice.status === INVOICES_STATES.REJECTED && (
          <div className="inline gap-1.5 pb-2">
            <span className="font-medium text-portal-destructive">
              Motivo de rejeição:
            </span>{' '}
            {invoice.reason}
          </div>
        )}
        <div className="inline items-center gap-1.5">
          <span className="font-medium">Data de emissão:</span>{' '}
          <span>{invoice.issuedDate}</span>
        </div>
        <div className="inline items-center gap-1.5">
          <span className="font-medium">Loja:</span> <span>{shop.name}</span>
        </div>
        <div className="inline items-center gap-1.5">
          <span className="font-medium">Valor:</span>{' '}
          <span>{invoice.amount} €</span>
        </div>

        {invoice.proofFileUrl ? (
          <a
            href={invoice.proofFileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium underline underline-offset-2"
          >
            Ver comprovativo submetido
          </a>
        ) : null}

        <span className="mt-2">
          ( Equivalente a {couponsEquivalent}{' '}
          {couponsEquivalent > 1 ? 'cupões' : 'cupão'} )
        </span>

        {rejected ? (
          <div className="mt-2 flex flex-row gap-2 text-portal-destructive">
            <AlertCircleIcon className="size-4" />
            <span className="w-[90%]">
              Por favor dirija-se ao Balcão de Informações com o comprovativo
              original da fatura
            </span>
          </div>
        ) : null}

        {pending ? (
          <div className="mt-2 flex flex-row gap-2 text-portal-destructive">
            <div>
              <AlertCircleIcon className="size-4" />
            </div>
            <span className="w-[90%]">Fatura a aguardar validação</span>
          </div>
        ) : null}

        {pending ? <DialogVoidInvoice invoiceId={invoice.ROWID} /> : null}
      </div>
    </div>
  );
}
